const actions = {
	SET_GROUP_NUMBER: "SET_GROUP_NUMBER"
};

export default actions;
